import IwStyleNormaliser from './IwStyleNormaliser';

const IwNormaliser = ({ children }) => {
    return <IwStyleNormaliser>{children}</IwStyleNormaliser>;
};

// eslint-disable-next-line import/no-default-export
export default IwNormaliser;
